import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pet-rehome-in-proccess-modal',
  templateUrl: './pet-rehome-in-proccess-modal.component.html',
})
export class PetRehomeInProccessModalComponent {
  @Input('modalRef') public modalRef: NgbModalRef;

  public closeModal() {
    this.modalRef.close();
  }

  public onConfirm() {
    this.closeModal();
  }

}
